"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueFromArray = exports.getSimpleRuleValues = exports.getSelectValue = exports.getBooleanOptions = exports.emptySimpleRule = exports.defaultRuleValueProps = exports.defaultRuleOperatorsProps = exports.defaultRule = exports["default"] = exports.computeInputType = exports.addUidsToRules = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _utils = require("@trs/utils");
var _Searchable = _interopRequireDefault(require("../formula/Searchable"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _Datepicker = _interopRequireDefault(require("../datepicker/Datepicker"));
var _select = _interopRequireDefault(require("../select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getBooleanOptions = exports.getBooleanOptions = R.memoizeWith(R.identity, function (labels) {
  return [{
    value: true,
    label: labels.ELIGIBILITY_YES
  }, {
    value: false,
    label: labels.ELIGIBILITY_NO
  }];
});
var getSelectValue = exports.getSelectValue = function getSelectValue(value, isMultiple) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (isMultiple && value instanceof Array) {
    return value.map(function (item) {
      return R.find(R.propEq('value', item), options) || {
        label: item,
        value: item
      };
    });
  }
  if (!isMultiple) {
    if (!(value instanceof Array)) return value;
    var rawValue = R.prop(0, value);
    return R.find(R.propEq('value', rawValue), options) || {
      value: rawValue,
      label: rawValue
    };
  }
  return [];
};
var getValueFromArray = exports.getValueFromArray = function getValueFromArray(value) {
  return value instanceof Array ? R.prop(0, value) || '' : '';
};
var emptySimpleRule = exports.emptySimpleRule = {
  variable: '',
  operator: '',
  values: []
};
var _addUidsToRules = exports.addUidsToRules = function addUidsToRules(rules) {
  var newRules = rules;
  if (newRules.eligibilityRows) {
    newRules.uid = (0, _uuid.v4)();
    newRules.eligibilityRows.map(function (item) {
      return _addUidsToRules(item);
    });
  } else {
    newRules.uid = (0, _uuid.v4)();
  }
  return newRules;
};
var getSimpleRuleValues = exports.getSimpleRuleValues = function getSimpleRuleValues(variable, operator, value, variableOperands) {
  var rule = R.clone(emptySimpleRule);
  rule.variable = R.prop('value', variable) || variable || '';
  rule.operator = R.prop('value', operator) || operator || '';
  rule.variableOperands = variableOperands;
  rule.values = R.prop('value', value) || (value instanceof Date ? value.toString() : value) || [];
  return rule;
};
var defaultRule = exports.defaultRule = {
  variable: null,
  operator: null,
  values: []
};
var defaultRuleValueProps = exports.defaultRuleValueProps = {
  disabled: true,
  type: 'string',
  valuesUrl: ''
};
var defaultRuleOperatorsProps = exports.defaultRuleOperatorsProps = {
  disabled: true
};
var getValueRendererProps = function getValueRendererProps(valueRenderer) {
  return valueRenderer ? {
    valueRenderer: valueRenderer
  } : {};
};
var getOperandData = function getOperandData(item, variableOperands) {
  var data = R.find(R.propEq('value', R.prop(0, item) || ''), variableOperands) || {};
  return data;
};

// update function and use HOC
var computeInputType = exports.computeInputType = function computeInputType(_ref) {
  var _ref$variableOperands = _ref.variableOperands,
    variableOperands = _ref$variableOperands === void 0 ? [] : _ref$variableOperands,
    errors = _ref.errors,
    onChange = _ref.onChange,
    type = _ref.type,
    value = _ref.value,
    lookUpValues = _ref.lookUpValues,
    allowsMultipleSelect = _ref.allowsMultipleSelect,
    id = _ref.id,
    labels = _ref.labels,
    operatorValue = _ref.operatorValue,
    valueRenderer = _ref.valueRenderer;
  var ValueInput;
  var inputProps;
  var handleOnChange = onChange;
  var operator = R.prop('value', operatorValue);
  if (operator === 'inlist' || operator === 'notinlist') {
    var variableOperand = getOperandData(value, variableOperands);
    ValueInput = _Searchable["default"];
    inputProps = _objectSpread({
      allowNumeric: false,
      error: errors,
      isFocused: true,
      tooltipPosition: 'top',
      uniqueKey: id,
      formulaChange: function formulaChange(item) {
        return onChange([item.value], [item]);
      }
    }, variableOperand);
    return {
      ValueInput: ValueInput,
      inputProps: inputProps,
      handleOnChange: handleOnChange
    };
  }
  if (!lookUpValues || lookUpValues.length === 0) {
    switch (type) {
      case 'boolean':
        ValueInput = _select["default"];
        inputProps = _objectSpread({
          searchable: false,
          options: getBooleanOptions(labels),
          multi: false,
          value: R.prop(0, value)
        }, getValueRendererProps(valueRenderer));
        handleOnChange = function handleOnChange(option) {
          onChange([option.value]);
        };
        break;
      case 'double':
      case 'integer':
      case 'decimal':
        if (operator === 'in' || operator === 'notin') {
          ValueInput = _select["default"];
          inputProps = _objectSpread(_objectSpread({
            separator: ';',
            type: 'number',
            withLocaleFormatNumber: true,
            transformer: function transformer(item) {
              if (/^([0-9]*\.?[0-9]*|[0-9]*\.?|\.?[0-9]*)$/.test(item)) {
                return item;
              }
              return '';
            },
            options: lookUpValues,
            multi: true,
            createable: true,
            value: getSelectValue(value, allowsMultipleSelect, lookUpValues)
          }, getValueRendererProps(valueRenderer)), {}, {
            placeholder: labels.ELIGIBILITY_CREATEABLE_SELECT_PLACEHOLDER
          });
          handleOnChange = function handleOnChange(options) {
            var values = options.map(function (val) {
              return val.value;
            });
            onChange(values);
          };
        } else {
          ValueInput = _Input["default"];
          inputProps = {
            fullWidth: true,
            className: 'input-number',
            value: getValueFromArray(value) || undefined,
            type: 'number',
            withLocaleFormatNumber: true
          };
          handleOnChange = function handleOnChange(event) {
            onChange([event.target.value]);
          };
        }
        break;
      case 'datetime':
        ValueInput = _Datepicker["default"];
        inputProps = {
          fullWidth: true,
          className: 'input-date',
          value: getValueFromArray(value)
        };
        handleOnChange = function handleOnChange(date) {
          onChange([(0, _utils.offsetTimezone)(date)]);
        };
        break;
      case 'string':
      default:
        if (operator === 'in' || operator === 'notin') {
          ValueInput = _select["default"];
          inputProps = _objectSpread(_objectSpread({
            separator: ';',
            searchable: false,
            options: lookUpValues,
            multi: true,
            createable: true,
            value: getSelectValue(value, allowsMultipleSelect, lookUpValues)
          }, getValueRendererProps(valueRenderer)), {}, {
            placeholder: labels.ELIGIBILITY_CREATEABLE_SELECT_PLACEHOLDER
          });
          handleOnChange = function handleOnChange(options) {
            var values = options.map(function (val) {
              return val.value;
            });
            onChange(values);
          };
        } else {
          ValueInput = _Input["default"];
          inputProps = {
            multiline: true,
            fullWidth: true,
            className: 'input-text',
            value: getValueFromArray(value),
            type: 'text'
          };
          handleOnChange = function handleOnChange(event) {
            onChange([event.target.value]);
          };
        }
        break;
    }
  } else {
    ValueInput = _select["default"];
    inputProps = _objectSpread(_objectSpread({
      searchable: true,
      options: lookUpValues,
      multi: allowsMultipleSelect,
      value: getSelectValue(value, allowsMultipleSelect, lookUpValues)
    }, getValueRendererProps(valueRenderer)), {}, {
      placeholder: labels.ELIGIBILITY_VALUE_SELECT_PLACEHOLDER || 'Search value'
    });
    if (!allowsMultipleSelect) {
      handleOnChange = function handleOnChange(option) {
        onChange([option.value]);
      };
    } else {
      handleOnChange = function handleOnChange(options) {
        var values = options.map(function (val) {
          return val.value;
        });
        onChange(values);
      };
    }
  }
  return {
    ValueInput: ValueInput,
    inputProps: inputProps,
    handleOnChange: handleOnChange
  };
};
var _default = exports["default"] = {
  getBooleanOptions: getBooleanOptions,
  getSelectValue: getSelectValue,
  getValueFromArray: getValueFromArray,
  emptySimpleRule: emptySimpleRule,
  addUidsToRules: _addUidsToRules,
  getSimpleRuleValues: getSimpleRuleValues,
  defaultRule: defaultRule,
  defaultRuleValueProps: defaultRuleValueProps,
  defaultRuleOperatorsProps: defaultRuleOperatorsProps
};